<header class="header flex-v-center">
  <div class="logo flex-v-center">
    <img class="logo-img" src="assets/img/Logo_Diana.png" alt="Logo Bild" />
    <div class="title-box hide-lt-sm">
      @if (currentTenantName$ | async; as currentTenantName) {
        <span class="logo-title"
          [class.logo-title-sm]=" currentTenantName.length > 35  && currentTenantName.length < 60"
          [class.logo-title-xs]="currentTenantName.length >= 60"
          >
          {{ currentTenantName$ | async }}
        </span>
      }
      <span class="logo-subtitle">{{'header.logo_subtitle' | translate}}</span>
    </div>
  </div>
  @if (isUserAuthenticated$ | async) {
    <div class="header-nav-items hide-lt-sm">
      @for (item of navItems; track item; let idx = $index) {
        <diana-nav-icon
          [idKey]="item.idKey"
          [iconName]="item.iconName"
          [textLabel]="item.textLabel"
          [hasHover]="!item.isDisabled"
          [isDisabled]="item.isDisabled"
          [isActive]="item && item.isActive ? true: false"
          [isOutlined]="item && item.isOutlined ? true: false"
          (iconClick)="setFilterView($event)"
          >
        </diana-nav-icon>
      }
      <!-- TODO: More menu can be extracted into a seprate component -->
      <!--<div
      [matMenuTriggerFor]="moreMenu"
      #trigger="matMenuTrigger"
      role="button"
      class="header-more-menu flex-v-center"
      >
      <mat-icon>{{
        trigger.menuOpen ? "expand_less" : "expand_more"
      }}</mat-icon>
      {{'general.label.more' | translate}}
    </div>
    <mat-menu #moreMenu="matMenu" class="more-menu-content">
      <button class="is-active" aria-label="Navigation Icon" *ngIf="hasTenantPermission" mat-menu-item [class.icon-active]="currentNavigation === '/tenants'" (click)="setFilterView('tenants')">
        <mat-icon [class.icon-active]="currentNavigation === '/tenants'">supervisor_account</mat-icon>{{'header.icon_label.tenants' | translate}}
      </button>
      <button class="is-active" aria-label="Navigation Icon" *ngIf="hasOrgUnitPermission" mat-menu-item [class.icon-active]="currentNavigation === '/org-units'" (click)="setFilterView('orgUnits')">
        <mat-icon  [class.icon-active]="currentNavigation === '/org-units'">lan</mat-icon>{{'header.icon_label.orgUnits' | translate}}
      </button>
      <button mat-menu-item>
        <mat-icon>bar_chart</mat-icon>{{'header.more_menu.tamv' | translate}}
      </button>
      <button mat-menu-item>
        <mat-icon>medication</mat-icon>{{'header.more_menu.isabv' | translate}}
      </button>
      <button mat-menu-item>
        <mat-icon>miscellaneous_services</mat-icon>{{'header.more_menu.remote_maintanance' | translate}}
      </button>
      <button mat-menu-item>
        <mat-icon>update</mat-icon>{{'header.more_menu.update' | translate}}
      </button>
    </mat-menu>-->
  </div>
  <div class="header-actions-container flex-v-center">
    <!-- <div role="button" class="header-action" (click)="search()">
    <mat-icon>search</mat-icon>
  </div>
  <div role="button" class="header-action" (click)="shoppingCart()">
    <mat-icon matBadge="1" matBadgeSize="small">shopping_cart</mat-icon>
  </div>
  <div role="button" class="header-action" (click)="notifications()">
    <mat-icon matBadge="3" matBadgeSize="small">notifications</mat-icon>
  </div> -->
  @if (hasMultipleOrgUnits$ | async) {
    <div class="org-unit-select flex-v-center">
      <mat-select
        [(value)]="currentOrgUnit"
        name="orgUnitChange"
        hideSingleSelectionIndicator="true"
        (selectionChange)="onOrgUnitChange($event)"
        >
        @for (orgUnit of orgUnitPermissions$ | async; track orgUnit) {
          <mat-option
            [value]="orgUnit.organizationalUnitId"
            >
            {{ orgUnit.orgName }}
          </mat-option>
        }
      </mat-select>
    </div>
  }
  <div [matMenuTriggerFor]="userMenu"
    role="button"
    [ngClass]="{switched: hasSwtichedTenant$ | async}"
    class="user-box flex-v-center hide-lt-sm">
    <div class="user-icon">
      <mat-icon>account_circle</mat-icon>
    </div>
    @if (currentUser$ | async; as user) {
      <div class="user-info">
        <div class="user-name">{{user?.firstName}} {{user?.lastName}}</div>
      </div>
    }
  </div>
  <div role="button"
    id="btnMobileUserMenu"
    class="header-action hide-gt-sm"
    [matMenuTriggerFor]="userMenu">
    <mat-icon>account_circle</mat-icon>
  </div>
  <mat-menu #userMenu="matMenu" class="user-menu-content">
    <!-- <button mat-menu-item (click)="menuItemSelected('dashboard')">
    <mat-icon>dashboard</mat-icon>Dashboard
  </button>
  <button mat-menu-item (click)="menuItemSelected('costs')">
    <mat-icon>money</mat-icon>Nutzung & Kosten
  </button>
  <button mat-menu-item (click)="menuItemSelected('bills')">
    <mat-icon>medication</mat-icon>Rechnungen
  </button>
  <button mat-menu-item (click)="menuItemSelected('orders')">
    <mat-icon>description</mat-icon>Bestellungen
  </button>
  <button mat-menu-item (click)="menuItemSelected('renew')">
    <mat-icon>autorenew</mat-icon>Vertragsverlängerung
  </button>-->
  @if (isDianaSuisseAvailable) {
    <button
      mat-menu-item
      (click)="openDianaSuisse()">
      <mat-icon>dns</mat-icon>DianaSuisse öffnen
    </button>
  }
  <button mat-menu-item id="settings" (click)="menuItemSelected('settings')">
    <mat-icon>settings</mat-icon>{{'header.user_menu.settings' | translate}}
  </button>
  <button mat-menu-item id="changePassword" (click)="menuItemSelected('password')">
    <mat-icon>password</mat-icon>{{'header.user_menu.change_password' | translate}}
  </button>
  <button mat-menu-item id="logout" (click)="menuItemSelected('logout')">
    <mat-icon>logout</mat-icon>{{'header.user_menu.logout' | translate}}
  </button>
  <mat-button-toggle-group name="fontStyle" aria-label="Font Style" class="change-lang">
    <mat-button-toggle (click)="menuItemSelected('de')" [checked]="selectedLanguage === 'de'">DE</mat-button-toggle>
    <mat-button-toggle (click)="menuItemSelected('it')" [checked]="selectedLanguage === 'it'">IT</mat-button-toggle>
    <mat-button-toggle (click)="menuItemSelected('fr')" [checked]="selectedLanguage === 'fr'">FR</mat-button-toggle>
  </mat-button-toggle-group>
  <div class="flex-jc-center padding-y-version-label version-icon-area">
    <span>{{ version }}</span>
    <mat-icon class="content-copy-icon" (click)="copyVersion()">content_copy</mat-icon>
  </div>
</mat-menu>
</div>
}
</header>
